import { forwardRef } from 'react';
import { useTranslation } from 'react-i18next';
import { IconComponent } from '@/components/IconComponent';
import { ModalSelectContainer } from '@/components/ModalSelect';
import type { ThemeMode } from '@/helpers/enums';
import { useGetCommonStore } from '@/store';
import {
  ScDepositWithWageringDesktop,
  ScDepositWithWageringMobile,
} from './styled';
import { WithWageringContent } from './WithWageringContent';

interface SelectDepositWithWageringProps {
  isInputAddon?: boolean;
  mode?: ThemeMode;
  toggleOpen: () => void;
  onChange: (currency: string) => void;
}

export const SelectDepositWithWagering = forwardRef<
  HTMLDivElement,
  SelectDepositWithWageringProps
>((props, ref) => {
  const { t } = useTranslation('deposits');
  const useCommonStore = useGetCommonStore();

  const isMobileDevice = useCommonStore.use.isMobileDevice();

  if (isMobileDevice)
    return (
      <ModalSelectContainer
        alignBottom
        bodyStyle={{
          padding: '0 16px',
          overflow: 'auto',
        }}
        gap={24}
        icon={<IconComponent name="currencyIcon" size="40px" />}
        onClose={props.toggleOpen}
        openOptionsInPortal
        title={t('balance.my')}
      >
        <ScDepositWithWageringMobile>
          <WithWageringContent {...props} />
        </ScDepositWithWageringMobile>
      </ModalSelectContainer>
    );

  return (
    <ScDepositWithWageringDesktop>
      <WithWageringContent {...props} ref={ref} />
    </ScDepositWithWageringDesktop>
  );
});
